<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest} width={205} height={16} viewBox="0 0 205 16">
	<path
		d="M95.0343 15.7109V14.1024H87.7848V8.65975H93.8224V7.05119H87.7848V1.91704H94.792V0.286455H86V15.7109H95.0343Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M106.289 15.7109C108.734 15.7109 110.629 15.0279 111.974 13.6617C113.34 12.2735 114.023 10.4005 114.023 7.9987C114.023 3.48153 111.158 0.286455 106.289 0.286455H101.705V15.7109H106.289ZM103.49 1.89501H106.289C108.117 1.89501 109.572 2.44588 110.607 3.54763C111.665 4.62735 112.194 6.12572 112.194 7.9987C112.194 11.8548 109.968 14.1244 106.289 14.1244H103.49V1.89501Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M121.584 15.7109V0.286455H119.799V15.7109H121.584Z" fill={getTailwindColor(color)} />
	<path
		d="M132.545 1.91704V15.7109H134.329V1.91704H139.045V0.286455H127.829V1.91704H132.545Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M147.077 15.7109V0.286455H145.292V15.7109H147.077Z" fill={getTailwindColor(color)} />
	<path
		d="M152.859 7.9987C152.859 12.5599 156.23 15.9974 160.814 15.9974C165.441 15.9974 168.812 12.5379 168.812 7.9987C168.812 3.48153 165.441 0 160.836 0C156.252 0 152.859 3.45949 152.859 7.9987ZM154.71 7.9987C154.71 4.407 157.332 1.67466 160.836 1.67466C164.339 1.67466 166.961 4.407 166.961 7.9987C166.961 9.8276 166.389 11.326 165.221 12.5379C164.053 13.7278 162.599 14.3227 160.836 14.3227C157.332 14.3227 154.71 11.6565 154.71 7.9987Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M177.282 15.7109V3.39339H177.415L185.391 15.7109H187.286V0.286455H185.524V12.604H185.391L177.327 0.286455H175.498V15.7109H177.282Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M193.864 11.1277C193.82 13.9261 196.354 16.0855 199.373 15.9974C201.004 15.9974 202.304 15.5787 203.273 14.7634C204.243 13.9261 204.728 12.8905 204.728 11.6345C204.728 5.39857 196.178 8.32922 196.178 4.12054C196.178 2.73234 197.258 1.63059 199.307 1.63059C201.4 1.63059 202.568 2.7103 202.568 4.4731H204.397C204.397 1.30006 201.643 0 199.329 0C197.831 0 196.641 0.39663 195.737 1.21192C194.834 2.00518 194.393 2.97472 194.393 4.12054C194.393 10.2903 202.921 6.89695 202.921 11.7446C202.921 13.3312 201.488 14.3448 199.439 14.3448C198.293 14.3448 197.368 14.0363 196.685 13.4193C196.002 12.8023 195.649 12.0311 195.649 11.1277H193.864Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M33.6096 3.01703V0.000209477H23.9905V16H33.7223V12.9828H27.0918V9.3941H33.0481V6.4228H27.0918V3.01703H33.6096Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M3.10168 6.35432V0H0V15.9998H3.10168V9.37156H8.94536V15.9998H12.0247V0H8.94536V6.35432H3.10168Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M53.9694 9.76009L47.2265 0H44.8666V15.9998H47.9682V6.21736L54.7111 15.9998H57.0711V0H53.9694V9.76009Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M72 15.9998V0H68.8987V15.9998H72Z" fill={getTailwindColor(color)} />
</SvgWrapper>
